import { useState } from 'react'
import { Link } from 'react-router-dom'
import classes from './ChatWidget.module.scss'
import { ChatAddStatus, chatAddBlockNote, clampChatBasketQuantity, MAX_CHAT_BASKET_QUANTITY } from './chatAddToBasket'
import { useChatAddToBasket } from './useChatAddToBasket'
import { ChatProduct } from './types'

interface ActionProps {
  product: ChatProduct
  quantity: number
  status: ChatAddStatus
  onQuantityChange: (next: number) => void
  onSubmit: () => void
}

/** Sunumsal katman: adet seçici + buton + satır içi sonuç. Redux'a bağlı değildir (test edilebilir). */
export function ProductAddAction({ product, quantity, status, onQuantityChange, onSubmit }: ActionProps) {
  const busy = status.kind === 'loading'
  const upper =
    product.stock && product.stock > 0 ? Math.min(product.stock, MAX_CHAT_BASKET_QUANTITY) : MAX_CHAT_BASKET_QUANTITY

  return (
    <div className={classes.productAdd}>
      <div className={classes.productAddRow}>
        <div className={classes.productQty} role='group' aria-label='Adet seçimi'>
          <button
            type='button'
            className={classes.productQtyButton}
            onClick={() => onQuantityChange(quantity - 1)}
            disabled={busy || quantity <= 1}
            aria-label='Adedi azalt'
          >
            −
          </button>
          <input
            className={classes.productQtyValue}
            type='number'
            inputMode='numeric'
            min={1}
            max={upper}
            value={quantity}
            onChange={e => onQuantityChange(Number(e.target.value))}
            disabled={busy}
            aria-label='Adet'
          />
          <button
            type='button'
            className={classes.productQtyButton}
            onClick={() => onQuantityChange(quantity + 1)}
            disabled={busy || quantity >= upper}
            aria-label='Adedi artır'
          >
            +
          </button>
        </div>
        <button type='button' className={classes.productAddButton} onClick={onSubmit} disabled={busy}>
          {busy ? 'Ekleniyor…' : 'Sepete ekle'}
        </button>
      </div>

      {status.kind === 'added' && (
        <div className={classes.productAddStatus} role='status'>
          {`✓ ${status.quantity} adet sepete eklendi · `}
          <Link to='/mycard'>Sepete git</Link>
        </div>
      )}
      {status.kind === 'error' && (
        <div className={`${classes.productAddStatus} ${classes.productAddStatusError}`} role='alert'>
          {status.message}
        </div>
      )}
    </div>
  )
}

/** Buton yerine yönlendirme notu (iQuote, Kaspersky); diğer kodlarda hiçbir şey çizmez. */
export function AddBlockNote({ product }: { product: ChatProduct }) {
  const note = chatAddBlockNote(product.addBlock)
  if (!note) return null

  return (
    <p className={classes.productAddNote}>
      {note.text}
      {note.link ? (
        <>
          {' '}
          <Link to={note.link.to}>{note.link.label}</Link>
        </>
      ) : null}
    </p>
  )
}

/** Kapsayıcı: adet durumu burada, portal çağrısı ve Redux eşitlemesi hook'ta. */
export default function ProductAddToBasket({ product }: { product: ChatProduct }) {
  const [quantity, setQuantity] = useState(1)
  const { status, add } = useChatAddToBasket(product)

  return (
    <ProductAddAction
      product={product}
      quantity={quantity}
      status={status}
      onQuantityChange={next => setQuantity(clampChatBasketQuantity(next, product.stock))}
      onSubmit={() => add(quantity)}
    />
  )
}
